import React, { useState, useEffect } from 'react';
import styles from './DateLine.module.css';
import { Popover, Spin } from 'antd';
import api from '../../api/axios';

const MONTHS = ['Yan', 'Fev', 'Mar', 'Apr', 'May', 'Iyu', 'Iyu', 'Avg', 'Sen', 'Okt', 'Noy', 'Dek'];
const MAX_DOTS = 4;

const DateLine = ({ serviceId }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!serviceId) return;
        setLoading(true);
        api.get(`/public/services/${serviceId}/schedule`)
            .then(res => setData(res.data?.data || []))
            .catch(() => setData([]))
            .finally(() => setLoading(false));
    }, [serviceId]);

    if (!serviceId) return null;

    if (loading) {
        return (
            <div className={`${styles.container} ${styles.loading}`}>
                <Spin size="small" />
            </div>
        );
    }

    if (!data.length) return null;

    return (
        <div className={styles.container}>
            <div
                className={styles.grid}
                style={{ gridTemplateColumns: `repeat(${Math.min(data.length, 7)}, 1fr)` }}
            >
                {data.map((item, idx) => {
                    const hasSlots = item.slots && item.slots.length > 0;
                    const emptyCount = Math.max(0, MAX_DOTS - (item.slots?.length || 0));

                    return (
                        <div
                            key={idx}
                            className={hasSlots ? `${styles.dayCell} ${styles.dayCellBusy}` : styles.dayCell}
                        >
                            <span className={hasSlots ? `${styles.dayBadge} ${styles.dayBadgeBusy}` : styles.dayBadge}>
                                {item.day} {MONTHS[item.month - 1]}
                            </span>
                            <div className={styles.dots}>
                                {(item.slots || []).map((slot, sIdx) => (
                                    <Popover
                                        key={sIdx}
                                        content={<div>{slot.title}</div>}
                                        title={`${slot.start != null ? slot.start : '?'}:00 - ${slot.end != null ? slot.end : '?'}:00`}
                                    >
                                        <div className={slot.source === 'order' ? `${styles.dot} ${styles.dotOrder}` : `${styles.dot} ${styles.dotService}`} />
                                    </Popover>
                                ))}
                                {[...Array(emptyCount)].map((_, i) => (
                                    <div key={`e${i}`} className={`${styles.dot} ${styles.dotEmpty}`} />
                                ))}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default DateLine;